(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-botella"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Puede haber dos secciones (ficha y resto): todo se busca en la página entera
    if (!document.querySelector('.pbt') || window.__pbtReady) return;
    window.__pbtReady = true;
    const root = document;
    const $ = (s) => root.querySelector(s);
      // Galería
      root.querySelectorAll('.gallery-thumbs button').forEach((b) => b.addEventListener('click', () => {
        root.querySelectorAll('.gallery-thumbs button').forEach((x) => x.classList.toggle('on', x === b));
        $('#mainImg').src = b.dataset.src;
      }));
    
      // Clips: se cargan y reproducen al acercarse
      const clips = [...root.querySelectorAll('video[data-src]')];
      if ('IntersectionObserver' in window) {
        const cio = new IntersectionObserver((es) => es.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else if (v.src) v.pause();
        }), { rootMargin: '300px 0px' });
        clips.forEach((v) => cio.observe(v));
      } else clips.forEach((v) => { v.src = v.dataset.src; v.autoplay = true; });
    
      // Vídeo vertical: arranca en silencio; al activar el sonido vuelve al principio
      const reel = $('#reel'), reelBtn = $('#reelSound');
      if (reel && reelBtn) reelBtn.addEventListener('click', () => {
        const on = reel.muted;
        reel.muted = !on;
        if (on) { reel.currentTime = 0; reel.play(); }
        reelBtn.querySelector('span').textContent = on ? 'Silenciar' : 'Activar sonido';
      });
    
      // Aparición al hacer scroll
      // En escritorio el tema hace scroll dentro de un contenedor, no en la ventana:
      // IntersectionObserver + scroll en fase de captura cubren ambos casos.
      const els = [...root.querySelectorAll('[data-reveal]')];
      const check = () => els.forEach((el) => { if (el.getBoundingClientRect().top < innerHeight * 0.88) el.classList.add('in'); });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
        els.forEach((el) => io.observe(el));
      }
      document.addEventListener('scroll', check, { passive: true, capture: true }); check();
    
      // Ritual: ciclo de 9 s (22:00 → 07:00)
      const steps = root.querySelectorAll('[data-step]');
      function ritual(now) {
        const t = (now / 9000) % 1;
        const p = Math.min(1, t / 0.85);
        $('#arc').setAttribute('stroke-dashoffset', (804 * (1 - p)).toFixed(1));
        const mins = Math.round(22 * 60 + p * 9 * 60) % (24 * 60);
        $('#clock').textContent = String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
        const ang = -Math.PI / 2 + p * Math.PI * 2;
        const cx = 150 + 128 * Math.cos(ang), cy = 150 + 128 * Math.sin(ang);
        ['#moon', '#sun'].forEach((id) => { $(id).setAttribute('cx', cx); $(id).setAttribute('cy', cy); });
        $('#moon').setAttribute('opacity', p < 0.85 ? 1 : 0);
        $('#sun').setAttribute('opacity', p >= 0.85 ? 1 : 0);
        const fill = Math.min(1, t / 0.12);
        $('#water').setAttribute('y', 262 - 180 * fill); $('#water').setAttribute('height', 180 * fill);
        $('#zz').setAttribute('opacity', p > 0.12 && p < 0.85 ? (0.5 + 0.5 * Math.sin(now / 300)).toFixed(2) : 0);
        const i = p < 0.12 ? 0 : p < 0.85 ? 1 : 2;
        steps.forEach((s, k) => s.classList.toggle('on', k === i));
        requestAnimationFrame(ritual);
      }
      requestAnimationFrame(ritual);
    
      // Comparativa
      const DATA = {
        plastic: { life: [18, 'Unos meses'], taste: [30, 'Puede saber a plástico'], look: [20, 'Desechable'], recycle: [25, 'Pocas veces'] },
        copper: { life: [100, 'Años'], taste: [100, 'Sin sabor a plástico'], look: [100, 'Una pieza para tu mesa'], recycle: [100, 'Infinitas veces'] },
      };
      function setMode(mode) {
        $('#board').className = 'compare-board is-' + mode;
        root.querySelectorAll('.compare-tabs button').forEach((b) => { const on = b.dataset.mode === mode; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); });
        Object.entries(DATA[mode]).forEach(([k, [w, label]]) => { root.querySelector(`[data-bar="${k}"]`).style.width = w + '%'; root.querySelector(`[data-label="${k}"]`).textContent = label; });
      }
      root.querySelectorAll('.compare-tabs button').forEach((b) => b.addEventListener('click', () => { setMode(b.dataset.mode); auto = false; }));
      let auto = true; setMode('plastic');
      setInterval(() => { if (auto) setMode($('#board').classList.contains('is-plastic') ? 'copper' : 'plastic'); }, 3500);
      const slider = $('#slider');
      const upd = () => { $('#perWeek').textContent = slider.value; $('#perYear').textContent = (slider.value * 52).toLocaleString('de-DE'); };
      slider.addEventListener('input', upd); upd();
    
      // Limpieza: pasos en bucle
      const clean = root.querySelectorAll('[data-clean]'); let ci = 0;
      setInterval(() => { clean.forEach((c, k) => c.classList.toggle('on', k === ci)); ci = (ci + 1) % clean.length; }, 1200);
    
      // Microscopio: bacterias que desaparecen en 16 h mientras llegan los iones de cobre (ciclo 10 s)
      (() => {
        const cv = root.querySelector('#scope'); const ctx = cv.getContext('2d'); const W = 600, R = 300;
        const rnd = (a, b) => a + Math.random() * (b - a);
        const inside = () => { let x, y; do { x = rnd(40, 560); y = rnd(40, 560); } while ((x - R) ** 2 + (y - R) ** 2 > 250 ** 2); return [x, y]; };
        const bac = Array.from({ length: 34 }, (_, i) => { const [x, y] = inside(); return { x, y, a: rnd(0, Math.PI), s: rnd(0.6, 1.2), t: rnd(0.15, 0.85), w: rnd(0, 6.28) }; });
        const ions = Array.from({ length: 90 }, () => { const ang = rnd(0, 6.28); return { ang, r: 300, sp: rnd(0.6, 1.4), tx: inside() }; });
        function frame(now) {
          const t = (now / 10000) % 1; const p = Math.min(1, t / 0.85); const h = Math.round(p * 16);
          root.querySelector('#hours').textContent = h + ' h';
          root.querySelector('#hoursBar').style.width = (p * 100) + '%';
          ctx.clearRect(0, 0, W, W);
          // agua
          const g = ctx.createRadialGradient(240, 210, 20, R, R, 300); g.addColorStop(0, 'rgba(120,190,210,0.18)'); g.addColorStop(1, 'rgba(10,30,40,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);
          // iones de cobre: entran desde el borde
          ions.forEach((o, i) => {
            const k = Math.min(1, p * o.sp * 1.6);
            const sx = R + o.r * Math.cos(o.ang), sy = R + o.r * Math.sin(o.ang);
            const x = sx + (o.tx[0] - sx) * k + Math.sin(now / 400 + i) * 4, y = sy + (o.tx[1] - sy) * k + Math.cos(now / 380 + i) * 4;
            ctx.beginPath(); ctx.arc(x, y, 4, 0, 6.28); ctx.fillStyle = 'rgba(240,165,113,' + (0.35 + 0.6 * k) + ')'; ctx.shadowColor = '#f0a571'; ctx.shadowBlur = 10; ctx.fill(); ctx.shadowBlur = 0;
          });
          // bacterias: se apagan cuando el tiempo supera su umbral
          bac.forEach((b) => {
            const fade = Math.max(0, Math.min(1, 1 - (p - b.t) / 0.12));
            if (fade <= 0) return;
            const x = b.x + Math.sin(now / 700 + b.w) * 6, y = b.y + Math.cos(now / 650 + b.w) * 6;
            ctx.save(); ctx.translate(x, y); ctx.rotate(b.a + Math.sin(now / 900 + b.w) * 0.3); ctx.scale(b.s * (0.6 + 0.4 * fade), b.s * (0.6 + 0.4 * fade));
            ctx.globalAlpha = fade; ctx.fillStyle = '#7fd1b9'; ctx.strokeStyle = '#3e9b82'; ctx.lineWidth = 2;
            ctx.beginPath(); ctx.ellipse(0, 0, 18, 8, 0, 0, 6.28); ctx.fill(); ctx.stroke();
            ctx.beginPath(); ctx.moveTo(18, 0); ctx.quadraticCurveTo(28, -6 + Math.sin(now / 120 + b.w) * 4, 36, 2); ctx.stroke();
            ctx.restore();
          });
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      })();
    
      // 1 botella de cobre vs. montaña de plástico
      (() => {
        const grid = root.querySelector('#pileGrid');
        function show(years) {
          const total = years * 364; const unit = years <= 1 ? 5 : years <= 3 ? 10 : years <= 5 ? 15 : 30;
          const n = Math.round(total / unit);
          grid.innerHTML = '';
          for (let i = 0; i < n; i++) { const el = document.createElement('i'); el.style.animationDelay = (i * 0.012) + 's'; grid.appendChild(el); }
          root.querySelector('#pileUnit').textContent = unit;
          const c = root.querySelector('#pileCount'); const t0 = performance.now();
          const step = (t) => { const k = Math.min(1, (t - t0) / 900); c.textContent = Math.round(total * k).toLocaleString('de-DE'); if (k < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
          root.querySelectorAll('[data-years]').forEach((b) => b.classList.toggle('on', +b.dataset.years === years));
        }
        let auto = true, idx = 0; const seq = [1, 3, 5, 10];
        root.querySelectorAll('[data-years]').forEach((b) => b.addEventListener('click', () => { auto = false; show(+b.dataset.years); }));
        show(1);
        setInterval(() => { if (!auto) return; idx = (idx + 1) % seq.length; show(seq[idx]); }, 3200);
      })();
    
      // Botón fijo en móvil
      document.addEventListener('scroll', (e) => { const y = e.target === document ? scrollY : (e.target.scrollTop || 0); $('#sticky').classList.toggle('show', y > 700); }, { passive: true, capture: true });

  // Compra real: añade al carrito, refresca el carrito del tema y lo abre
  const errorBox = root.querySelector('[data-pbt-error]');
  async function addToCart(items, btn) {
    const label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Añadiendo…';
    // Evento estándar del tema: refresca el carrito lateral y lo abre solo (como el botón del tema)
    let ev = null, deferred = null;
    try { ev = await import('@shopify/events'); } catch (e) {}
    if (ev) {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new ev.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })),
        promise: deferred.promise,
      }));
    }
    const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    try {
      const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo añadir al carrito.');
      if (errorBox) errorBox.hidden = true;
      btn.textContent = '¡Añadido!';
      const cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      if (deferred) {
        deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'pol-botella', sourceId: 'pol-botella', itemCount: items.length, didError: false } });
      } else {
        window.location.href = base + 'cart';
      }
    } catch (e) {
      if (deferred) deferred.reject(e);
      if (errorBox) { errorBox.textContent = e.message; errorBox.hidden = false; }
    } finally {
      setTimeout(() => { btn.disabled = false; btn.innerHTML = label; }, 1400);
    }
  }
  // Selector de 3 opciones: todos los botones de compra usan la opción marcada
  const opts = [...root.querySelectorAll('input[name="pbt-opt"]')];
  const current = () => opts.find((o) => o.checked) || opts[0];
  function syncOpt() {
    const o = current(); if (!o) return;
    root.querySelectorAll('[data-pbt-buy-price]').forEach((e) => { e.textContent = o.dataset.priceLabel; });
    root.querySelectorAll('.opt').forEach((l) => l.classList.toggle('is-on', l.contains(o)));
  }
  opts.forEach((o) => o.addEventListener('change', syncOpt)); syncOpt();
  root.querySelectorAll('[data-pbt-buy]').forEach((b) => b.addEventListener('click', () => {
    const o = current();
    if (o) addToCart(JSON.parse(o.dataset.items), b);
  }));

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-continue-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-continue-bar')) {
    const TIERS = [[2, 25], [3, 35], [4, 45], [5, 50]];
    const NOT_JEWEL = ['Joyero', 'Hogar', 'Cuidado personal'];

    customElements.define('pol-continue-bar', class extends HTMLElement {
      connectedCallback() {
        // Colgada directamente del <body>: dentro de la sección, algún contenedor con
        // transform/animación hacía que la barra «fija» saliera a media pantalla.
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return; // se vuelve a llamar a connectedCallback ya en su sitio
        }
        if (this.ready) return;
        this.ready = true;

        // Móvil: el carrito no se abre al añadir (manda la barra). Escritorio: se abre como siempre.
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.syncDrawer = () => {
          const drawer = document.querySelector('cart-drawer-component');
          if (!drawer) return;
          if (this.mobile.matches) {
            if (drawer.hasAttribute('auto-open')) { drawer.dataset.polAutoOpen = '1'; drawer.removeAttribute('auto-open'); }
          } else if (drawer.dataset.polAutoOpen === '1') {
            drawer.setAttribute('auto-open', '');
          }
        };
        this.syncDrawer();
        this.mobile.addEventListener('change', this.syncDrawer);

        this.querySelector('[data-open-cart]')?.addEventListener('click', (e) => {
          const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (!trigger) return;
          e.preventDefault();
          trigger.click();
        });

        this.render(Number(this.dataset.count), Number(this.dataset.qty), false);
        if (Number(this.dataset.count) > 0) this.load();
        this.refresh = () => this.load();
        this.onPageShow = (e) => { if (e.persisted) this.load(); };
        // Eventos de carrito de Horizon (estándar) y del tema
        document.addEventListener('shopify:cart:lines-update', this.refresh);
        document.addEventListener('cart:update', this.refresh);
        window.addEventListener('pageshow', this.onPageShow);
        import('@shopify/events')
          .then(({ StandardEvents }) => {
            this.evt = StandardEvents.cartLinesUpdate;
            this.onLines = (e) => (e.promise ? e.promise.then(() => this.load(), () => {}) : this.load());
            document.addEventListener(this.evt, this.onLines);
          })
          .catch(() => {});
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        this.mobile.removeEventListener('change', this.syncDrawer);
        document.removeEventListener('shopify:cart:lines-update', this.refresh);
        document.removeEventListener('cart:update', this.refresh);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.evt) document.removeEventListener(this.evt, this.onLines);
      }

      async load() {
        try {
          const cart = await (await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
          const joyas = cart.items.filter((i) => !NOT_JEWEL.includes(i.product_type));
          const qty = joyas.reduce((a, i) => a + i.quantity, 0);
          const base = joyas.reduce((a, i) => a + i.original_line_price, 0);
          this.joyas = joyas;
          const ahorro = joyas.reduce((a, i) => a + i.original_line_price - i.final_line_price, 0);
          this.render(cart.item_count, qty, cart.item_count > Number(this.dataset.count), base, ahorro);
          this.dataset.count = cart.item_count;
        } catch (e) {}
      }

      render(count, qty, bump, base = 0, ahorro = 0) {
        this.hidden = count === 0;
        const cartText = this.querySelector('[data-cart-text]');
        if (cartText) cartText.textContent = (this.dataset.cartLabel || '').replace('[n]', count);

        const msg = this.querySelector('[data-msg]');
        if (this.dataset.showTiers !== 'true' || qty === 0 || !base) {
          msg.hidden = true;
        } else {
          msg.hidden = false;
          const current = TIERS.filter(([q]) => qty >= q).pop();
          const next = TIERS.find(([q]) => qty < q);
          // Solo euros, sin porcentajes. La nueva pieza se calcula al precio de la joya más barata del carrito.
          const eur = (c) => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
          const joyas = this.joyas || [];
          const barata = Math.min(...joyas.map((i) => i.original_price));
          // Lo que baja lo que ya lleva al subir de tramo + el descuento de la nueva (redondeo por unidad, como Shopify)
          const otra = next
            ? joyas.reduce((a, i) => a + Math.floor(i.original_price * next[1] / 100) * i.quantity - (i.original_line_price - i.final_line_price), 0) + Math.floor(barata * next[1] / 100)
            : 0;
          if (!next) msg.innerHTML = '¡Descuento máximo! Ya ahorras <strong>' + eur(ahorro) + '</strong>';
          else if (!current) msg.innerHTML = 'Añade otra pieza y ahorra <strong>' + eur(otra) + '</strong>';
          else msg.innerHTML = 'Ya ahorras ' + eur(ahorro) + '. Añade otra pieza y ahorra <strong>' + eur(otra) + ' más</strong>';
        }

        if (bump) {
          this.classList.remove('is-bump');
          void this.offsetWidth;
          this.classList.add('is-bump');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-hero-gravedad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-gravity-hero')) {
    class PolGravityHero extends HTMLElement {
      connectedCallback() {
        this.swatches = Array.from(this.querySelectorAll('.pol-gz__swatch'));
        this.bgs = Array.from(this.querySelectorAll('.pol-gz__bg'));
        this.products = Array.from(this.querySelectorAll('.pol-gz__product'));
        this.label = this.querySelector('[data-pol-gz-label]');
        this.cta = this.querySelector('[data-pol-gz-cta]');
        this.price = this.querySelector('[data-pol-gz-price]');

        this.current = 0;
        this.swatches.forEach((swatch, i) => {
          swatch.addEventListener('click', () => {
            /* Cambia al instante y el ciclo automático sigue desde este acabado */
            this.select(i);
            this.restartAutoplay();
          });
          swatch.addEventListener('keydown', (e) => {
            const dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
            if (!dir) return;
            e.preventDefault();
            const next = (i + dir + this.swatches.length) % this.swatches.length;
            this.select(next);
            this.restartAutoplay();
            this.swatches[next].focus();
          });
        });
        this.syncTabindex(0);

        /* En el editor: al seleccionar un bloque "Acabado", mostrarlo */
        this.onBlockSelect = (e) => {
          const i = this.swatches.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i === -1) return;
          this.editorLocked = true;
          this.stopAutoplay();
          this.select(i);
        };
        this.onBlockDeselect = () => {
          this.editorLocked = false;
          this.restartAutoplay();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.setupAutoplay();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.stopAutoplay();
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      /* Cambio automático de acabado: solo mientras el hero está en pantalla y la pestaña visible */
      setupAutoplay() {
        this.delay = parseInt(this.dataset.autoplay, 10);
        if (!this.delay || this.swatches.length < 2) return;
        this.inView = true;
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.restartAutoplay();
        });
        this.observer.observe(this);
        this.onVisibility = () => this.restartAutoplay();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.restartAutoplay();
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        if (!this.delay || this.editorLocked || !this.inView || document.hidden) return;
        this.timer = setInterval(() => {
          this.select((this.current + 1) % this.swatches.length);
        }, this.delay);
      }

      syncTabindex(active) {
        this.swatches.forEach((s, i) => (s.tabIndex = i === active ? 0 : -1));
      }

      select(index) {
        const swatch = this.swatches[index];
        if (!swatch) return;
        this.current = index;
        const toggle = (list) => list.forEach((el, i) => el.classList.toggle('is-active', i === index));
        toggle(this.bgs);
        toggle(this.products);
        this.swatches.forEach((s, i) => {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-checked', i === index ? 'true' : 'false');
        });
        this.syncTabindex(index);

        if (this.label) this.label.textContent = swatch.dataset.label;
        if (swatch.dataset.btnBg) this.style.setProperty('--pol-gz-btn-bg', swatch.dataset.btnBg);
        if (swatch.dataset.btnText) this.style.setProperty('--pol-gz-btn-text', swatch.dataset.btnText);
        if (this.cta) this.cta.href = swatch.dataset.url || this.dataset.defaultUrl;
        if (this.price) {
          this.price.textContent = swatch.dataset.price || '';
          this.price.hidden = !swatch.dataset.price;
        }
      }
    }
    customElements.define('pol-gravity-hero', PolGravityHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-lm-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-lm-slider')) {
    customElements.define('pol-lm-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.pol-lmh__slide')];
        this.dots = [...this.querySelectorAll('.pol-lmh__dot')];
        this.index = 0;
        if (this.slides.length < 2) return;
        this.querySelectorAll('.pol-lmh__arrow').forEach((b) =>
          b.addEventListener('click', () => { this.go(this.index + Number(b.dataset.dir)); this.restart(); })
        );
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(Number(d.dataset.index)); this.restart(); }));
        let x0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
          x0 = null;
        }, { passive: true });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      go(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          s.classList.toggle('is-active', k === this.index);
          s.setAttribute('aria-hidden', k === this.index ? 'false' : 'true');
        });
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.index));
      }
      start() {
        const secs = Number(this.dataset.autoplay);
        if (!secs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), secs * 1000);
      }
      stop() { clearInterval(this.timer); }
      restart() { this.stop(); this.start(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-lm-pack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-lm-pack')) {
    customElements.define('pol-lm-pack', class extends HTMLElement {
      connectedCallback() {
        this.size = Number(this.dataset.size) || 3;
        this.pct = Number(this.dataset.pct) || 0;
        this.items = [];
        this.syncedSig = '';
        this.slots = [...this.querySelectorAll('[data-slot]')];
        this.cta = this.querySelector('[data-checkout]');
        this.cards = [...this.querySelectorAll('.pol-lmk__card')];

        this.querySelectorAll('[data-variant-select]').forEach((sel) => {
          sel.addEventListener('change', () => {
            const card = sel.closest('.pol-lmk__card');
            const opt = sel.selectedOptions[0];
            const btn = card.querySelector('[data-add]');
            btn.dataset.variant = opt.value;
            btn.dataset.price = opt.dataset.price;
            if (opt.dataset.img) btn.dataset.img = opt.dataset.img;
            btn.dataset.variantTitle = opt.dataset.title;
            const price = card.querySelector('.pol-lmk__price');
            if (price) price.textContent = this.money(Number(opt.dataset.price));
          });
          sel.dispatchEvent(new Event('change'));
        });

        this.querySelectorAll('[data-filter]').forEach((chip) =>
          chip.addEventListener('click', () => {
            const f = chip.dataset.filter;
            this.querySelectorAll('[data-filter]').forEach((c) => {
              const on = c === chip;
              c.classList.toggle('is-active', on);
              c.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            this.cards.forEach((card) => { card.hidden = !!f && card.dataset.type !== f; });
          })
        );

        this.querySelectorAll('[data-add]').forEach((btn) =>
          btn.addEventListener('click', () => {
            if (this.items.length >= this.size) return;
            this.items.push({
              id: Number(btn.dataset.variant),
              product: btn.dataset.product,
              price: Number(btn.dataset.price),
              title: btn.dataset.title + (btn.dataset.variantTitle ? ' - ' + btn.dataset.variantTitle : ''),
              img: btn.dataset.img || '',
            });
            this.render(this.items.length - 1);
          })
        );

        this.slots.forEach((slot) => {
          slot.addEventListener('click', () => this.removeAt(Number(slot.dataset.slot)));
          slot.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.removeAt(Number(slot.dataset.slot)); }
          });
        });

        this.cta.addEventListener('click', () => this.checkout());

        // Al volver con «atrás» desde el pago, el navegador de escritorio restaura
        // la página de su caché (bfcache) con el joyero lleno y el botón bloqueado.
        // Se reinicia igual que al recargar.
        this.onPageShow = (e) => {
          if (!e.persisted) return;
          this.items = [];
          this.syncedSig = '';
          this.synced = false;
          this.pending = null;
          const err = this.querySelector('[data-error]');
          if (err) err.hidden = true;
          this.render();
        };
        window.addEventListener('pageshow', this.onPageShow);
        this.render();
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
      }

      removeAt(i) {
        if (!this.items[i]) return;
        this.items.splice(i, 1);
        this.render();
      }

      money(cents) {
        const fmt = this.dataset.money || '{' + '{amount_with_comma_separator}} €';
        const n = (cents / 100).toFixed(2);
        const [int, dec] = n.split('.');
        const dots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const commas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
          if (k === 'amount_with_comma_separator') return dots + ',' + dec;
          if (k === 'amount_no_decimals_with_comma_separator') return dots;
          if (k === 'amount_no_decimals') return commas;
          return commas + '.' + dec;
        });
      }

      render(popIndex) {
        const n = this.items.length;
        const full = n >= this.size;
        const bundle = Number(this.dataset.bundlePrice || 0);
        const sum = bundle ? bundle : this.items.reduce((a, it) => a + it.price, 0);
        const save = !bundle && full && this.pct > 0 ? this.items.reduce((a, it) => a + Math.floor(it.price * this.pct / 100), 0) : 0;
        const subRow = this.querySelector('[data-subtotal]');
        if (bundle && subRow) subRow.closest('.pol-lmk__row').hidden = true;

        this.querySelector('[data-count]').textContent = n;
        this.querySelector('[data-subtotal]').textContent = this.money(sum);
        this.querySelector('[data-total]').textContent = this.money(sum - save);
        const saveRow = this.querySelector('[data-save-row]');
        if (saveRow) { saveRow.hidden = !save; this.querySelector('[data-save]').textContent = '−' + this.money(save); }

        const left = this.size - n;
        const hint = this.querySelector('[data-hint]');
        if (bundle) {
          if (full) hint.textContent = 'Joyero completo: ' + this.size + ' piezas por ' + this.money(bundle) + '.';
          else if (n === 0) hint.textContent = 'Elige ' + this.size + ' piezas. El joyero completo cuesta ' + this.money(bundle) + '.';
          else hint.textContent = 'Te ' + (left === 1 ? 'falta 1 pieza' : 'faltan ' + left + ' piezas') + ' para completar tu joyero.';
        } else if (full) hint.textContent = this.pct > 0 ? 'Joyero completo. Te ahorras ' + this.money(save) + '.' : 'Joyero completo.';
        else if (n === 0) hint.textContent = 'Elige ' + this.size + ' piezas para completar tu joyero.';
        else hint.textContent = 'Te ' + (left === 1 ? 'falta 1 pieza' : 'faltan ' + left + ' piezas') + (this.pct > 0 ? ' para ahorrar un ' + this.pct + ' %.' : '.');

        this.slots.forEach((slot, i) => {
          const it = this.items[i];
          slot.classList.toggle('is-filled', !!it);
          slot.classList.remove('is-pop');
          if (it) {
            slot.innerHTML = it.img ? '<img alt="" src="' + it.img + '">' : '<span aria-hidden="true">✓</span>';
            slot.setAttribute('role', 'button');
            slot.setAttribute('tabindex', '0');
            slot.setAttribute('aria-label', 'Quitar ' + it.title);
            if (i === popIndex) { void slot.offsetWidth; slot.classList.add('is-pop'); }
          } else {
            slot.innerHTML = '<span class="pol-lmk__slot-empty" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg>' + (i + 1) + '</span>';
            slot.removeAttribute('role');
            slot.removeAttribute('tabindex');
            slot.removeAttribute('aria-label');
          }
        });

        const counts = {};
        this.items.forEach((it) => { counts[it.product] = (counts[it.product] || 0) + 1; });
        this.querySelectorAll('[data-add]').forEach((b) => {
          if (b.dataset.soldout === undefined) b.dataset.soldout = b.disabled ? '1' : '0';
          b.disabled = b.dataset.soldout === '1' || full;
          const c = counts[b.dataset.product] || 0;
          b.classList.toggle('is-added', c > 0);
          const badge = this.querySelector('[data-count-for="' + b.dataset.product + '"]');
          if (badge) { badge.hidden = c === 0; badge.textContent = 'En tu joyero' + (c > 1 ? ' ×' + c : ''); }
        });
        this.cta.disabled = !full;
        this.syncCart(full).catch(() => {});
      }

      // Deja en el carrito exactamente las piezas del joyero (sin duplicar las de antes).
      syncCart(full) {
        const express = this.querySelector('[data-express]');
        if (express) express.hidden = true;
        const sig = full ? this.items.map((it) => it.id).sort().join(',') : '';
        if (sig === this.syncedSig) { if (express && full && this.synced) express.hidden = false; return this.pending || Promise.resolve(); }
        this.syncedSig = sig;
        this.synced = false;
        const run = async () => {
          const cart = await (await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
          const updates = {};
          cart.items.forEach((l) => { if (l.properties && l.properties._pack) updates[l.key] = 0; });
          if (Object.keys(updates).length) {
            await fetch(this.dataset.updateUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
          }
          if (!full) return;
          const map = new Map();
          this.items.forEach((it) => map.set(it.id, (map.get(it.id) || 0) + 1));
          let items;
          if (this.dataset.bundleVariant) {
            const props = { _pack: 'Joyero de ' + this.size };
            this.items.forEach((it, i) => { props['Pieza ' + (i + 1)] = it.title; });
            items = [{ id: Number(this.dataset.bundleVariant), quantity: 1, properties: props }];
          } else {
            items = [...map].map(([id, quantity]) => ({ id, quantity, properties: { _pack: 'Joyero de ' + this.size } }));
          }
          const res = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!res.ok) {
            const data = await res.json().catch(() => ({}));
            throw new Error(data.description || data.message || 'No se pudo añadir al carrito.');
          }
          if (sig === this.syncedSig) {
            this.synced = true;
            if (express) express.hidden = false;
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: null, sourceId: this.id, data: { source: 'pol-lm-pack' } } }));
          }
        };
        this.pending = run().catch((e) => {
          this.syncedSig = null;
          const err = this.querySelector('[data-error]');
          err.textContent = e.message;
          err.hidden = false;
          throw e;
        });
        return this.pending;
      }

      async checkout() {
        if (this.items.length < this.size) return;
        const err = this.querySelector('[data-error]');
        err.hidden = true;
        this.cta.disabled = true;
        try {
          await this.syncCart(true);
          const code = (this.dataset.code || '').trim();
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          const dest = this.dataset.checkoutUrl || '/checkout';
          window.location.href = code
            ? root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest)
            : dest;
        } catch (e) {
          err.textContent = e.message;
          err.hidden = false;
          this.cta.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-prelander"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-prelander')) {
    class PolPrelander extends HTMLElement {
      connectedCallback() {
        this.sticky = this.querySelector('[data-sticky]');
        this.offer = this.querySelector('.pol-pl__offer');
        this.progress = this.querySelector('[data-progress]');
        this.stickyAlways = this.sticky && this.sticky.hasAttribute('data-always');

        if (this.sticky || this.progress) {
          /* El tema puede desplazar dentro de .page-wrapper en vez de la ventana:
             se escucha el scroll en fase de captura y se mide la propia sección. */
          this.onScroll = () => {
            const rect = this.getBoundingClientRect();
            if (this.progress) {
              const total = rect.height - window.innerHeight;
              const pct = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
              this.progress.style.transform = `scaleX(${pct})`;
            }
            if (this.sticky) {
              /* Aparece al empezar a leer y se retira cuando la oferta (con su propio botón) está en pantalla */
              const started = rect.top < -280;
              const o = this.offer && this.offer.getBoundingClientRect();
              const offerVisible = o && o.top < window.innerHeight - 80 && o.bottom > 0;
              const on = (this.stickyAlways || started) && !offerVisible;
              this.sticky.classList.toggle('is-visible', on);
              this.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
              const a = this.sticky.querySelector('a');
              if (a) a.tabIndex = on ? 0 : -1;
            }
          };
          document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        }

        /* Cuenta atrás hasta una fecha real; al terminar se oculta */
        this.timer = this.querySelector('.pol-pl__timer');
        if (this.timer) {
          const end = new Date(this.timer.dataset.ends.replace(' ', 'T')).getTime();
          if (!isNaN(end)) {
            const pad = (n) => String(n).padStart(2, '0');
            const tick = () => {
              const left = end - Date.now();
              if (left <= 0) { this.timer.hidden = true; clearInterval(this.interval); return; }
              this.timer.querySelector('[data-u="h"]').textContent = pad(Math.floor(left / 3600000));
              this.timer.querySelector('[data-u="m"]').textContent = pad(Math.floor((left % 3600000) / 60000));
              this.timer.querySelector('[data-u="s"]').textContent = pad(Math.floor((left % 60000) / 1000));
              this.timer.hidden = false;
            };
            tick();
            this.interval = setInterval(tick, 1000);
          }
        }
      }

      disconnectedCallback() {
        if (this.onScroll) {
          document.removeEventListener('scroll', this.onScroll, { capture: true });
          window.removeEventListener('resize', this.onScroll);
        }
        clearInterval(this.interval);
      }
    }
    customElements.define('pol-prelander', PolPrelander);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-raspador"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.prs');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    // Galería
    root.querySelectorAll('.prs-thumbs button').forEach((b) => b.addEventListener('click', () => {
      root.querySelectorAll('.prs-thumbs button').forEach((x) => x.classList.toggle('on', x === b));
      root.querySelector('#prsMain').src = b.dataset.src;
    }));
    // Aparición al hacer scroll (en escritorio el tema hace scroll dentro de un contenedor)
    const els = [...root.querySelectorAll('[data-reveal]')];
    const check = () => els.forEach((el) => { if (el.getBoundingClientRect().top < innerHeight * 0.9) el.classList.add('in'); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
      els.forEach((el) => io.observe(el));
    }
    document.addEventListener('scroll', check, { passive: true, capture: true }); check();
    // Barra fija en móvil
    const sticky = root.querySelector('#prsSticky');
    if (sticky) document.addEventListener('scroll', (e) => { const y = e.target === document ? scrollY : (e.target.scrollTop || 0); sticky.classList.toggle('show', y > 700); }, { passive: true, capture: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-razones-cobre"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.polRazonesCobre) return;
    window.polRazonesCobre = true;

    const mix = (a, b, t) => a + (b - a) * t;
    const mixColor = (a, b, t) => '#' + [1, 3, 5].map((i) => Math.round(mix(parseInt(a.substr(i, 2), 16), parseInt(b.substr(i, 2), 16), t)).toString(16).padStart(2, '0')).join('');
    const fmt = (n) => Number(n).toLocaleString('de-DE');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Vídeos: se cargan y reproducen al acercarse; se pausan fuera de pantalla
    const vids = [...document.querySelectorAll('video[data-prz-src]')];
    if (vids.length && 'IntersectionObserver' in window) {
      const vio = new IntersectionObserver((es) => es.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) {
          // Portada y vídeo se piden solo al acercarse
          if (!v.src) { if (v.dataset.przPoster) v.poster = v.dataset.przPoster; v.src = v.dataset.przSrc; }
          if (!reduce) v.play().catch(() => {});
        } else if (v.src && v.muted) v.pause();
      }), { rootMargin: '400px 0px' });
      vids.forEach((v) => vio.observe(v));
    } else vids.forEach((v) => { if (v.dataset.przPoster) v.poster = v.dataset.przPoster; v.src = v.dataset.przSrc; v.autoplay = true; });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-prz-reel-sound]');
      if (!btn) return;
      const v = btn.parentElement.querySelector('video');
      const on = v.muted;
      v.muted = !on;
      if (on) { v.currentTime = 0; v.play(); }
      btn.querySelector('span').textContent = on ? 'Silenciar' : 'Activar sonido';
    });

    function revealAll(root) {
      const els = [...root.querySelectorAll('[data-prz-reveal]')];
      const show = (el) => {
        if (el.classList.contains('prz-in')) return;
        el.classList.add('prz-in');
        el.querySelectorAll('[data-prz-count]').forEach((c) => {
          const end = Number(c.dataset.przCount) || 0;
          if (reduce) { c.textContent = fmt(end); return; }
          const t0 = performance.now();
          const step = (t) => { const p = Math.min(1, (t - t0) / 1800); c.textContent = fmt(Math.round(end * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
        });
      };
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold: 0.15 }) : null;
      els.forEach((el) => (io ? io.observe(el) : show(el)));
      // Respaldo por si el observador no se dispara
      const check = () => els.forEach((el) => { if (el.getBoundingClientRect().top < innerHeight * 0.9) show(el); });
      addEventListener('scroll', check, { passive: true });
      check();
    }

    function drawAdjust(el, now) {
      const q = (s) => el.querySelector(s);
      const t = (1 - Math.cos(((now / 4200) % 1) * Math.PI * 2)) / 2;
      const rx = mix(36, 66, t), ry = mix(27, 48, t), cx = 150, cy = 96;
      const w = q('[data-wrist]'); w.setAttribute('rx', rx); w.setAttribute('ry', ry);
      const Rx = rx + 10, Ry = ry + 10, g = (mix(12, 46, t) * Math.PI) / 180;
      const p = (a) => [cx + Rx * Math.cos(a), cy + Ry * Math.sin(a)];
      const [x0, y0] = p(Math.PI / 2 + g), [x1, y1] = p(Math.PI / 2 - g + Math.PI * 2);
      q('[data-arc]').setAttribute('d', `M${x0} ${y0} A ${Rx} ${Ry} 0 1 1 ${x1} ${y1}`);
      q('[data-end-l]').setAttribute('cx', x0); q('[data-end-l]').setAttribute('cy', y0);
      q('[data-end-r]').setAttribute('cx', x1); q('[data-end-r]').setAttribute('cy', y1);
      const ay = Math.max(y0, y1) + 14;
      q('[data-arrows]').setAttribute('d', `M${x0 + 4} ${ay} L${x1 - 4} ${ay} M${x0 + 10} ${ay - 5} L${x0 + 4} ${ay} L${x0 + 10} ${ay + 5} M${x1 - 10} ${ay - 5} L${x1 - 4} ${ay} L${x1 - 10} ${ay + 5}`);
      q('[data-gap-txt]').setAttribute('y', ay + 18);
      el.querySelectorAll('[data-adj]').forEach((l, i) => l.classList.toggle('is-on', (t >= 0.5) === (i === 1)));
    }

    function drawWarm(el, now) {
      const q = (s) => el.querySelector(s);
      const from = Number(el.dataset.from) || 20, to = Number(el.dataset.to) || 33;
      const s = (now / 1000) % 7;
      const t = s < 0.6 ? 0 : s < 4 ? (s - 0.6) / 3.4 : s < 6.4 ? 1 : 1 - (s - 6.4) / 0.6;
      const k = 1 - Math.pow(1 - t, 2);
      q('[data-deg]').textContent = Math.round(mix(from, to, k));
      q('[data-cw1]').setAttribute('stop-color', mixColor('#9a8a80', '#f0b07a', k));
      q('[data-cw2]').setAttribute('stop-color', mixColor('#5f5048', '#a9552d', k));
      q('[data-glow]').setAttribute('opacity', k.toFixed(2));
      const h = mix(30, 104, k); q('[data-merc]').setAttribute('y', 130 - h); q('[data-merc]').setAttribute('height', h);
      q('[data-cuff-txt]').textContent = k < 0.15 ? el.dataset.wordA : el.dataset.wordB;
    }

    function drawPatina(el, now) {
      const s = (now / 1000) % 7;
      const step = s < 1.2 ? 0 : s < 3.8 ? 1 : 2;
      let p = s < 1.2 ? 0 : s < 3.8 ? (s - 1.2) / 2.6 : 1;
      if (s > 6.4) p = 1 - (s - 6.4) / 0.6;
      const sweep = el.querySelector('[data-sweep]');
      if (sweep) sweep.setAttribute('width', (p * 220).toFixed(1));
      const lemon = el.querySelector('[data-lemon]');
      if (lemon) {
        lemon.setAttribute('opacity', step === 1 ? '1' : '0');
        lemon.setAttribute('transform', 'translate(' + (40 + p * 140).toFixed(1) + ' ' + (40 + Math.sin(p * Math.PI * 4) * 10).toFixed(1) + ') rotate(' + (p * 220).toFixed(0) + ')');
      }
      const sp = el.querySelector('[data-sparkles]');
      if (sp) sp.setAttribute('opacity', step === 2 && s < 6.4 ? (0.55 + 0.45 * Math.sin(s * 6)).toFixed(2) : '0');
      el.querySelectorAll('[data-pat]').forEach((l, k) => l.classList.toggle('is-on', k === step));
    }

    function drawRitual(el, now) {
      const q = (s) => el.querySelector(s);
      const t = (now / 9000) % 1, p = Math.min(1, t / 0.85);
      q('[data-arc]').setAttribute('stroke-dashoffset', (804 * (1 - p)).toFixed(1));
      const mins = Math.round(22 * 60 + p * 9 * 60) % (24 * 60);
      q('[data-clock]').textContent = String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
      const ang = -Math.PI / 2 + p * Math.PI * 2, cx = 150 + 128 * Math.cos(ang), cy = 150 + 128 * Math.sin(ang);
      ['[data-moon]', '[data-sun]'].forEach((s) => { q(s).setAttribute('cx', cx); q(s).setAttribute('cy', cy); });
      q('[data-moon]').setAttribute('opacity', p < 0.85 ? 1 : 0); q('[data-sun]').setAttribute('opacity', p >= 0.85 ? 1 : 0);
      const fill = Math.min(1, t / 0.12); q('[data-water]').setAttribute('y', 262 - 180 * fill); q('[data-water]').setAttribute('height', 180 * fill);
      q('[data-zz]').setAttribute('opacity', p > 0.12 && p < 0.85 ? (0.5 + 0.5 * Math.sin(now / 300)).toFixed(2) : 0);
      const i = p < 0.12 ? 0 : p < 0.85 ? 1 : 2;
      el.querySelectorAll('[data-rstep]').forEach((s, k) => s.classList.toggle('is-on', k === i));
    }

    const scopes = new WeakMap();
    function drawScope(cv, now) {
      let st = scopes.get(cv);
      const R = 300, rnd = (a, b) => a + Math.random() * (b - a);
      const inside = () => { let x, y; do { x = rnd(40, 560); y = rnd(40, 560); } while ((x - R) ** 2 + (y - R) ** 2 > 250 ** 2); return [x, y]; };
      if (!st) {
        st = { ctx: cv.getContext('2d'),
          bac: Array.from({ length: 30 }, () => { const [x, y] = inside(); return { x, y, a: rnd(0, 3.1), s: rnd(0.6, 1.2), t: rnd(0.15, 0.85), w: rnd(0, 6.28) }; }),
          ions: Array.from({ length: 80 }, () => ({ ang: rnd(0, 6.28), sp: rnd(0.6, 1.4), tx: inside() })) };
        scopes.set(cv, st);
      }
      const box = cv.closest('.prz__sci'); const ctx = st.ctx;
      const t = (now / 10000) % 1, p = Math.min(1, t / 0.85);
      box.querySelector('[data-hours]').textContent = Math.round(p * 16) + ' h';
      box.querySelector('[data-hours-bar]').style.width = (p * 100) + '%';
      ctx.clearRect(0, 0, 600, 600);
      st.ions.forEach((o, i) => {
        const k = Math.min(1, p * o.sp * 1.6), sx = R + 300 * Math.cos(o.ang), sy = R + 300 * Math.sin(o.ang);
        const x = sx + (o.tx[0] - sx) * k + Math.sin(now / 400 + i) * 4, y = sy + (o.tx[1] - sy) * k + Math.cos(now / 380 + i) * 4;
        ctx.beginPath(); ctx.arc(x, y, 4, 0, 6.28); ctx.fillStyle = 'rgba(240,165,113,' + (0.35 + 0.6 * k) + ')'; ctx.fill();
      });
      st.bac.forEach((b) => {
        const fade = Math.max(0, Math.min(1, 1 - (p - b.t) / 0.12)); if (fade <= 0) return;
        const x = b.x + Math.sin(now / 700 + b.w) * 6, y = b.y + Math.cos(now / 650 + b.w) * 6;
        ctx.save(); ctx.translate(x, y); ctx.rotate(b.a + Math.sin(now / 900 + b.w) * 0.3); ctx.scale(b.s * (0.6 + 0.4 * fade), b.s * (0.6 + 0.4 * fade));
        ctx.globalAlpha = fade; ctx.fillStyle = '#7fd1b9'; ctx.strokeStyle = '#3e9b82'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.ellipse(0, 0, 18, 8, 0, 0, 6.28); ctx.fill(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(18, 0); ctx.quadraticCurveTo(28, -6 + Math.sin(now / 120 + b.w) * 4, 36, 2); ctx.stroke();
        ctx.restore();
      });
    }

    function initPile(el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      const grid = el.querySelector('[data-pile-grid]'), perDay = Number(el.dataset.perDay) || 1;
      const show = (years) => {
        const total = Math.round(years * 364 * perDay), unit = total <= 500 ? 5 : total <= 1500 ? 10 : total <= 2500 ? 15 : 30;
        grid.innerHTML = '';
        for (let i = 0; i < Math.round(total / unit); i++) { const b = document.createElement('i'); b.style.animationDelay = (i * 0.012) + 's'; grid.appendChild(b); }
        const c = el.querySelector('[data-pile-count]'), t0 = performance.now();
        const step = (t) => { const k = Math.min(1, (t - t0) / 900); c.textContent = fmt(Math.round(total * k)); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
        el.querySelectorAll('[data-years]').forEach((b) => b.classList.toggle('is-on', +b.dataset.years === years));
      };
      let auto = true, idx = 0; const seq = [1, 3, 5, 10];
      el.querySelectorAll('[data-years]').forEach((b) => b.addEventListener('click', () => { auto = false; show(+b.dataset.years); }));
      show(1);
      setInterval(() => { if (!auto) return; idx = (idx + 1) % seq.length; show(seq[idx]); }, 3200);
    }

    function drawChart(el, now) {
      const t = (now / 8000) % 1, p = Math.min(1, t / 0.8);
      const line = el.querySelector('[data-chart-line]');
      line.setAttribute('stroke-dashoffset', (100 * (1 - p)).toFixed(1));
      const pt = line.getPointAtLength(line.getTotalLength() * p);
      const dot = el.querySelector('[data-chart-dot]'); dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
      el.querySelector('[data-chart-clip]').setAttribute('width', 260 * p);
      el.querySelector('[data-chart-hours]').textContent = Math.round(p * 16) + ' h';
      el.querySelector('[data-chart-zero]').setAttribute('opacity', p >= 1 ? 1 : 0);
    }

    function drawDecay(el, now) {
      const years = Number(el.dataset.years) || 450;
      const t = (now / 9000) % 1, p = Math.min(1, t / 0.75), k = 1 - Math.pow(1 - p, 2);
      el.querySelector('[data-decay-num]').textContent = fmt(Math.round(years * k));
      el.querySelector('[data-decay-bar]').style.width = (k * 100) + '%';
      el.querySelector('[data-decay-plastic]').style.opacity = (1 - 0.6 * k).toFixed(2);
    }

    function drawClean(el, now) {
      const i = Math.floor(now / 1200) % 4;
      el.querySelectorAll('[data-clean]').forEach((c, k) => c.classList.toggle('is-on', k === i));
    }

    // Una gota recorre el camino del agua; cada parada se enciende al pasar
    function drawTrip(el, now) {
      const p = el.querySelector('[data-trip-path]');
      const n = Math.min(6, Number(el.dataset.n) || 6), cyc = 2000 * n + 1800;
      if (!el._len) {
        el._len = p.getTotalLength();
        // paradas repartidas a lo largo de la tubería
        el.querySelectorAll('[data-trip-stop]').forEach((g, j) => { const q = p.getPointAtLength(el._len * j / Math.max(1, n - 1)); g.setAttribute('transform', 'translate(' + q.x + ' ' + q.y + ')'); });
      }
      const t = Math.min(1, (now % cyc) / (2000 * n));
      const k = t < 1 ? t : 1;
      const pt = p.getPointAtLength(el._len * k);
      el.querySelector('[data-trip-drop]').setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ' ' + (pt.y - 2).toFixed(1) + ')');
      el.querySelector('[data-trip-water]').setAttribute('stroke-dashoffset', (100 - k * 100).toFixed(2));
      const i = Math.min(n - 1, Math.floor(k * (n - 1) + 0.15));
      el.querySelectorAll('[data-trip-stop]').forEach((g, j) => g.classList.toggle('is-on', j <= i));
      el.querySelectorAll('[data-trip-label]').forEach((d, j) => d.classList.toggle('is-on', j === i));
      el.querySelector('[data-trip-glass]').setAttribute('height', i === n - 1 ? 14 * Math.min(1, ((now % cyc) - 2000 * (n - 1)) / 1500) : 0);
      el.querySelector('[data-trip-glass]').setAttribute('y', i === n - 1 ? 14 - 14 * Math.min(1, ((now % cyc) - 2000 * (n - 1)) / 1500) : 14);
    }

    // Corte de tubería: con los años crece la capa de cal y aparece la biopelícula
    function drawPipe(el, now) {
      const years = Number(el.dataset.years) || 30;
      const t = (now / 8000) % 1, p = Math.min(1, t / 0.8), k = 1 - Math.pow(1 - p, 2);
      el.querySelector('[data-pipe-num]').textContent = Math.round(years * k);
      const r = 92 - 30 * k;
      el.querySelector('[data-pipe-water]').setAttribute('r', r.toFixed(1));
      const film = el.querySelector('[data-pipe-film]');
      if (!film.childElementCount) {
        let html = '';
        for (let i = 0; i < 46; i++) { const a = (i / 46) * Math.PI * 2 + (i % 3) * 0.05; html += '<circle data-a="' + a.toFixed(3) + '" data-o="' + ((i * 37) % 100) / 100 + '" r="' + (3 + (i % 4)) + '" fill="#7fae6a"/>'; }
        film.innerHTML = html;
      }
      film.querySelectorAll('circle').forEach((c) => {
        const a = Number(c.dataset.a), on = Math.max(0, Math.min(1, (k - Number(c.dataset.o) * 0.7) * 4));
        c.setAttribute('cx', (120 + Math.cos(a) * (r + 1)).toFixed(1));
        c.setAttribute('cy', (120 + Math.sin(a) * (r + 1)).toFixed(1));
        c.setAttribute('opacity', on.toFixed(2));
      });
    }

    // Botella de 1 litro que se llena de partículas mientras sube el contador
    function drawMicro(el, now) {
      const total = Number(el.dataset.count) || 240000;
      const dots = el.querySelector('[data-micro-dots]');
      if (!dots.childElementCount) {
        let html = '', seed = 7;
        const rnd = () => (seed = (seed * 9301 + 49297) % 233280) / 233280;
        for (let i = 0; i < 160; i++) html += '<circle cx="' + (26 + rnd() * 68).toFixed(1) + '" cy="' + (50 + rnd() * 196).toFixed(1) + '" r="' + (0.8 + rnd() * 2.2).toFixed(1) + '" fill="' + (i % 5 ? '#f3e9d8' : '#f0b48f') + '" opacity="0"/>';
        dots.innerHTML = html;
        el._dots = [...dots.children];
      }
      const t = (now / 8000) % 1, p = Math.min(1, t / 0.75), k = 1 - Math.pow(1 - p, 3);
      el.querySelector('[data-micro-num]').textContent = fmt(Math.round(total * k / 1000) * 1000);
      const shown = Math.round(el._dots.length * k);
      el._dots.forEach((c, i) => {
        c.setAttribute('opacity', i < shown ? '0.85' : '0');
        if (i < shown) c.setAttribute('transform', 'translate(0 ' + (Math.sin(now / 900 + i) * 2).toFixed(1) + ')');
      });
    }

    // Prelander de regalo
    const seg = (t, a, b) => Math.max(0, Math.min(1, (t - a) / (b - a)));
    const ease3 = (x) => 1 - Math.pow(1 - x, 3);

    // Flores, perfume, bombones… «otra vez»; y este año se abre la caja con la pulsera
    function drawGift(el, now) {
      const g = el._g || (el._g = {
        cards: [...el.querySelectorAll('[data-g-card]')], stamps: [...el.querySelectorAll('[data-g-stamp]')],
        now: el.querySelector('[data-g-now]'), lid: el.querySelector('[data-g-lid]'), br: el.querySelector('[data-g-bracelet]'),
        glow: el.querySelector('[data-g-glow]'), sparks: [...el.querySelectorAll('[data-g-spark]')],
      });
      const t = reduce ? 0.85 : (now / 10000) % 1, out = 1 - seg(t, 0.94, 1), dim = seg(t, 0.46, 0.52);
      g.cards.forEach((c, i) => {
        const a = ease3(seg(t, 0.03 + i * 0.12, 0.1 + i * 0.12)), s = seg(t, 0.08 + i * 0.12, 0.12 + i * 0.12);
        c.style.opacity = (a * (1 - 0.5 * dim) * out).toFixed(3);
        c.style.transform = 'translateY(' + ((1 - a) * 14).toFixed(1) + 'px) scale(' + (1 - 0.06 * dim).toFixed(3) + ')';
        g.stamps[i].style.opacity = s.toFixed(3);
        g.stamps[i].style.transform = 'rotate(-12deg) scale(' + (1.6 - 0.6 * ease3(s)).toFixed(3) + ')';
      });
      const n = ease3(seg(t, 0.5, 0.58)), l = ease3(seg(t, 0.6, 0.68)), r = ease3(seg(t, 0.64, 0.76));
      g.now.style.opacity = (n * out).toFixed(3);
      g.now.style.transform = 'translateY(' + ((1 - n) * 18).toFixed(1) + 'px)';
      g.lid.setAttribute('transform', 'translate(' + (l * 54).toFixed(1) + ' ' + (l * 4).toFixed(1) + ') rotate(' + (l * 34).toFixed(1) + ' 100 82)');
      g.br.setAttribute('transform', 'translate(0 ' + (110 - r * 64).toFixed(1) + ')');
      g.glow.setAttribute('opacity', (r * 0.9).toFixed(3));
      g.sparks.forEach((s, i) => s.setAttribute('opacity', (reduce ? 1 : Math.sin(seg(t, 0.72 + i * 0.04, 0.84 + i * 0.04) * Math.PI)).toFixed(3)));
    }

    // 30 días de prueba: el anillo se llena día a día y aparecen las dos salidas
    function drawGuar(el, now) {
      const g = el._g || (el._g = {
        arc: el.querySelector('[data-gu-arc]'), dot: el.querySelector('[data-gu-dot]'), num: el.querySelector('[data-gu-num]'),
        yes: el.querySelector('[data-gu-yes]'), no: el.querySelector('[data-gu-no]'), days: Number(el.dataset.days) || 30,
      });
      const t = reduce ? 0.9 : (now / 9000) % 1, out = 1 - seg(t, 0.94, 1), p = ease3(seg(t, 0.04, 0.6)), a = (p * 360 - 90) * Math.PI / 180;
      g.arc.style.strokeDashoffset = (427.26 * (1 - p)).toFixed(1);
      g.arc.style.opacity = g.dot.style.opacity = out.toFixed(3);
      g.dot.setAttribute('cx', (80 + 68 * Math.cos(a)).toFixed(1));
      g.dot.setAttribute('cy', (80 + 68 * Math.sin(a)).toFixed(1));
      g.num.textContent = Math.max(1, Math.round(g.days * p));
      [[g.yes, 0.62], [g.no, 0.7]].forEach(([s, a0]) => {
        const k = ease3(seg(t, a0, a0 + 0.08));
        s.style.opacity = (k * out).toFixed(3);
        s.style.transform = 'translateX(' + ((1 - k) * -16).toFixed(1) + 'px)';
      });
    }

    // La pulsera con los años: coge pátina mientras pasan las etapas
    function drawHeir(el, now) {
      const g = el._g || (el._g = {
        stops: ['[data-h1]', '[data-h2]', '[data-h3]'].map((s) => el.querySelector(s)), spots: el.querySelector('[data-h-spots]'),
        shine: el.querySelector('[data-h-shine]'), year: el.querySelector('[data-h-year]'), steps: [...el.querySelectorAll('[data-h-step]')],
        y0: Number(el.dataset.year) || 2026,
      });
      const t = reduce ? 0.86 : (now / 11000) % 1, p = seg(t, 0.04, 0.8), k = p * (1 - seg(t, 0.9, 1));
      const nuevo = ['#f0b07a', '#b4673a', '#7a3f1f'], viejo = ['#a87a58', '#6b4530', '#3f2616'];
      g.stops.forEach((s, i) => s.setAttribute('stop-color', mixColor(nuevo[i], viejo[i], k)));
      g.spots.setAttribute('opacity', (0.45 * k).toFixed(3));
      g.shine.setAttribute('opacity', (0.45 - 0.33 * k).toFixed(3));
      g.year.textContent = g.y0 + Math.round(30 * p * p);
      const n = g.steps.length, on = t > 0.9 ? -1 : Math.min(n - 1, Math.floor(p * n * 0.999));
      g.steps.forEach((s, i) => s.classList.toggle('is-on', i === on));
    }

    // Animaciones: se buscan una vez y solo se dibujan las que están en pantalla (ahorra CPU y batería en el móvil)
    const ANIMS = [
      ['[data-prz-adjust]', (el, t) => drawAdjust(el, reduce ? 0 : t)], ['[data-prz-warm]', drawWarm], ['[data-prz-patina]', drawPatina],
      ['[data-prz-ritual]', drawRitual], ['[data-prz-scope]', drawScope], ['[data-prz-clean]', drawClean],
      ['[data-prz-chart]', drawChart], ['[data-prz-decay]', drawDecay],
      ['[data-prz-trip]', drawTrip], ['[data-prz-pipe]', drawPipe], ['[data-prz-micro]', drawMicro],
      ['[data-prz-gift]', drawGift], ['[data-prz-guar]', drawGuar], ['[data-prz-heir]', drawHeir],
    ];
    let anims = [];
    const visibles = new Set();
    const aio = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? visibles.add(e.target) : visibles.delete(e.target))), { rootMargin: '150px 0px' }) : null;
    function collectAnims() {
      if (aio) anims.forEach(([el]) => aio.unobserve(el));
      visibles.clear();
      anims = [];
      ANIMS.forEach(([sel, fn]) => document.querySelectorAll(sel).forEach((el) => { anims.push([el, fn]); if (aio) aio.observe(el); else visibles.add(el); }));
      const t0 = reduce ? 4000 : performance.now();
      anims.forEach(([el, fn]) => fn(el, t0)); // primer dibujo de todas
    }
    function loop(now) {
      const t = reduce ? 4000 : now;
      for (const [el, fn] of anims) if (visibles.has(el)) fn(el, t);
      if (!reduce) requestAnimationFrame(loop);
    }

    function init() {
      document.querySelectorAll('.prz').forEach(revealAll);
      document.querySelectorAll('[data-prz-pile]').forEach(initPile);
      collectAnims();
      requestAnimationFrame(loop);
      const sticky = document.querySelector('[data-prz-sticky]');
      if (sticky) addEventListener('scroll', () => sticky.classList.toggle('is-on', scrollY > 900), { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', () => { document.querySelectorAll('.prz').forEach(revealAll); collectAnims(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-resenas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-reviews')) {
    class PolReviews extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.pol-re__slide'));
        this.dots = Array.from(this.querySelectorAll('.pol-re__dot'));
        this.current = 0;
        if (this.slides.length < 2) return;

        this.querySelectorAll('.pol-re__arrow').forEach((btn) =>
          btn.addEventListener('click', () => {
            this.go(this.current + parseInt(btn.dataset.dir, 10));
            this.restart();
          })
        );
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.go(parseInt(dot.dataset.go, 10));
            this.restart();
          })
        );

        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i > -1) { this.locked = true; this.stop(); this.go(i); }
        };
        this.onBlockDeselect = () => { this.locked = false; this.restart(); };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.delay = parseInt(this.dataset.autoplay, 10);
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(index) {
        const n = this.slides.length;
        this.current = (index + n) % n;
        this.slides.forEach((s, i) => {
          const on = i === this.current;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        if (!this.delay || this.locked) return;
        this.timer = setInterval(() => this.go(this.current + 1), this.delay);
      }
    }
    customElements.define('pol-reviews', PolReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-tc-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-countdown')) {
    customElements.define('pol-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = this.parseEnd(this.dataset.end, this.dataset.tz);
        this.timer = this.querySelector('[data-timer]');
        if (!this.end) return;
        this.vals = { h: this.querySelector('[data-v="h"]'), m: this.querySelector('[data-v="m"]'), s: this.querySelector('[data-v="s"]') };
        this.dayBox = this.querySelector('[data-unit="d"]');
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
      // «2026-10-31 23:59» en la zona horaria elegida (por defecto Madrid)
      parseEnd(str, tz) {
        const m = (str || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
        if (!m) return null;
        const [, y, mo, d, hh = '23', mi = '59'] = m;
        const utcGuess = Date.UTC(+y, +mo - 1, +d, +hh, +mi, 59);
        try {
          const fmt = new Intl.DateTimeFormat('en-US', { timeZone: tz || 'Europe/Madrid', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          const p = Object.fromEntries(fmt.formatToParts(new Date(utcGuess)).map((x) => [x.type, x.value]));
          const asTz = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
          return utcGuess - (asTz - utcGuess);
        } catch (e) { return utcGuess; }
      }
      set(el, v) {
        const s = String(v).padStart(2, '0');
        if (el && el.textContent !== s) {
          el.textContent = s;
          // Reinicia la animación del dígito sin forzar al navegador a recalcular la página (antes: void el.offsetWidth cada segundo)
          el.classList.remove('is-tick');
          requestAnimationFrame(() => el.classList.add('is-tick'));
        }
      }
      tick() {
        let left = Math.floor((this.end - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(this.interval);
          if (this.dataset.after === 'hide') this.hidden = true;
          else if (this.timer) this.timer.hidden = true;
          return;
        }
        const d = Math.floor(left / 86400); left -= d * 86400;
        const h = Math.floor(left / 3600); left -= h * 3600;
        const m = Math.floor(left / 60); const s = left - m * 60;
        if (this.dayBox) {
          this.dayBox.hidden = d === 0;
          if (d > 0) this.set(this.dayBox.querySelector('strong'), d);
        }
        this.set(this.vals.h, h); this.set(this.vals.m, m); this.set(this.vals.s, s);
        if (this.timer) this.timer.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-tc-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pol-tc-landing')) {
    customElements.define('pol-tc-landing', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('[data-progress]');
        this.sticky = this.querySelector('[data-sticky]');
        this.offer = this.querySelector('#tl-offer');
        this.onScroll = () => {
          const r = this.getBoundingClientRect();
          const total = r.height - window.innerHeight;
          const pct = total > 0 ? Math.min(100, Math.max(0, (-r.top / total) * 100)) : 0;
          if (this.bar) this.bar.style.width = pct + '%';
          if (this.sticky) {
            let show = -r.top > 500;
            if (this.offer) {
              const o = this.offer.getBoundingClientRect();
              if (o.top < window.innerHeight && o.bottom > 0) show = false;
            }
            this.sticky.classList.toggle('is-visible', show);
            this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            const a = this.sticky.querySelector('a');
            if (a) a.tabIndex = show ? 0 : -1;
          }
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
